import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import HistoryContext, { useHistory } from "@insite/mobius/utilities/HistoryContext";
import loadPunchoutUserIdentityList from "@TKCCP/Store/Data/PunchoutUserIdentity/Handlers/LoadPunchoutUserIdentity";
import {
    getUserIdentityDataView,
    UserIdentityDataViewContext,
} from "@TKCCP/Store/Data/PunchoutUserIdentity/PunchoutUserIdentitySelector";
import addUpdatePunchoutUserIdentity from "@TKCCP/Store/Pages/PunchoutUserIdentity/Handlers/AddUpdatePunchoutUserIdentity";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import { UserIdentityCollection } from "@TKCCP/Types/ApiModels";
import PunchoutUserIdentityGrid from "@TKCCP/Widgets/PunchoutIdentity/PunchoutUserIdentityGrid";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationStateTKCCP) => {
    const { search } = getLocation(state);
    const parsedQuery = parseQueryString<{ userid?: string }>(search);
    return {
        userIdentitesDataView: getUserIdentityDataView(state, state.pagePunchoutUserIdentity.getPunchoutParameter),
        getPunchoutParameter: state.pagePunchoutUserIdentity.getPunchoutParameter,
        userId: parsedQuery.userid,
    };
};

const mapDispatchToProps = {
    loadPunchoutUserIdentityList,
    addUpdatePunchoutUserIdentity,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const AddPunchoutIdentityPage = ({
    id,
    loadPunchoutUserIdentityList,
    userIdentitesDataView,
    getPunchoutParameter,
    addUpdatePunchoutUserIdentity,
    userId,
}: Props) => {
    const history = useHistory();
    let firstLoad = false;
    useEffect(() => {
        firstLoad = true;
        getPunchoutParameter.userId = userId || "";
        loadPunchoutUserIdentityList(getPunchoutParameter);
    }, [userId]);

    // useEffect(() => {
    //     if (!firstLoad) {
    //         const queryString = qs.stringify(getPunchoutParameter);
    //         history.replace(`${location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
    //     }
    // }, [getPunchoutParameter]);

    useEffect(() => {
        // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
        if (!userIdentitesDataView.value && !userIdentitesDataView.isLoading) {
            loadPunchoutUserIdentityList(getPunchoutParameter);
        }
    });

    const value = userIdentitesDataView.value;

    const savePunchoutIdentityUserHandler = (userIdentityCollection: UserIdentityCollection) => {
        // eslint-disable-next-line no-console
        // console.log(userIdentityCollection.userIdentityList);
        addUpdatePunchoutUserIdentity({
            userIdentityList:
                userIdentityCollection.userIdentityList != null ? userIdentityCollection.userIdentityList : null,
            onSuccess: response => {
                history.push("/MyAccount/PunchoutIdentityPage");
            },
        });
    };

    return (
        <Page>
            <UserIdentityDataViewContext.Provider value={userIdentitesDataView}>
                <Zone contentId={id} zoneName="Content" />
                <Modals />
                <PunchoutUserIdentityGrid
                    userIdentityModel={userIdentitesDataView.value}
                    savePunchoutIdentityUsers={savePunchoutIdentityUserHandler}
                ></PunchoutUserIdentityGrid>
            </UserIdentityDataViewContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AddPunchoutIdentityPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;
export const AddPunchoutIdentityPageContext = "AddPunchoutIdentityPage";
